import { createSlice } from "@reduxjs/toolkit";
import userList from "../../../rtk-apis/user/userList";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const userListSlice = createSlice({
  name: "userListSlice",
  initialState,
  reducers: {
    closeUserListModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(userList.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(userList.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(userList.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default userListSlice.reducer;
export const { closeUserListModal } = userListSlice.actions;
